import { render } from "./CreateEditCategory.vue?vue&type=template&id=4f623587"
import script from "./CreateEditCategory.vue?vue&type=script&lang=js"
export * from "./CreateEditCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__